export function RouteTemplateFormViewModeError() {
  return <div>Something went wrong, please close the modal and try again.</div>;
}
